// ************** 在线备课讲义  ****************

// 课件详情
export const COURSEWARE_GET_COURSEWARE_DETAIL = 'COURSEWARE_GET_COURSEWARE_DETAIL';
export const COURSEWARE_SET_COURSEWARE_DETAIL = 'COURSEWARE_SET_COURSEWARE_DETAIL';
// 保存讲义
export const COURSEWARE_SAVE_COURSEWARE = 'COURSEWARE_SAVE_COURSEWARE';

// 设置添加题目页面当前展示的内容
export const COURSEWARE_SET_CONTENT = 'COURSEWARE_SET_CONTENT';

// 在线讲义增加题目页面---修改讲义的类型
export const COURSEWARE_PUT_STAGE = 'COURSEWARE_PUT_STAGE';

//  在线讲义增加题目页面---修改讲义的考法
export const COURSEWARE_PUT_CATEGORY = 'COURSEWARE_PUT_CATEGORY';

// 添加题目
export const COURSEWARE_ADD_QUESTION = 'COURSEWARE_ADD_QUESTION';

// 移除题目
export const COURSEWARE_REMOVE_QUESTION = 'COURSEWARE_REMOVE_QUESTION';

// 获取备课推荐题目
export const COURSEWARE_GET_RECOMMEND_QUESTIONS = 'COURSEWARE_GET_RECOMMEND_QUESTIONS';
export const COURSEWARE_SET_RECOMMEND_QUESTIONS = 'COURSEWARE_SET_RECOMMEND_QUESTIONS';

// 添加推荐题目
export const COURSEWARE_ADD_RECOMMEND_QUESTIONS = 'COURSEWARE_ADD_RECOMMEND_QUESTIONS';

// 添加题目
export const COURSEWARE_ADD_QUESTIONS = 'COURSEWARE_ADD_QUESTIONS';

// 添加题库题目
export const COURSEWARE_ADD_QUESTION_TIKU = 'COURSEWARE_ADD_QUESTION_TIKU';

// 移除题库题目
export const COURSEWARE_REMOVE_QUESTION_TIKU = 'COURSEWARE_REMOVE_QUESTION_TIKU';

// 根据id移除已添加的题目
export const COURSEWARE_REMOVE_QUESTION_BYID = 'COURSEWARE_REMOVE_QUESTION_BYID';

// 清空题库题目
export const COURSEWARE_CLEAR_QUESTION_TIKU = 'COURSEWARE_CLEAR_QUESTION_TIKU';

// 设置已经添加到课件中的题库题目，将toAddQuestionInTiKu中的元素移到addedQuestionsInTiKu
export const COURSEWARE_ADDED_QUESTION_TIKU = 'COURSEWARE_ADDED_QUESTION_TIKU';



// WEBPACK FOOTER //
// ./src/views/index/store/types/types_courseware.js